import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OuiButtonModule } from 'omnium-ui/button';
import { OuiDocumentViewer } from 'omnium-ui/document-viewer';
import { OuiIconModule } from 'omnium-ui/icon';
import { DocumentsService } from 'projects/fiche-conseil-lib/src/lib/services/documents.service';
import { StorageFile } from '../../../models/generated/graphql';
import { OuiSlidePanelService } from 'omnium-ui/layout';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
  templateUrl: './simple-document-viewer.component.html',
  selector: 'app-simple-document-viewer',
  standalone: true,
  styleUrls: ['./simple-document-viewer.component.scss'],
  imports: [CommonModule, OuiDocumentViewer, OuiIconModule, OuiButtonModule],
})
export class SimpleDocumentViewerComponent {
  creationDate?: string;
  downloadUrl?: string;
  fileName?: string;

  private _storageFile?: StorageFile | undefined;
  public get storageFile(): StorageFile | undefined {
    return this._storageFile;
  }
  @Input()
  public set storageFile(value: StorageFile | undefined) {
    this._storageFile = value;
    this.initDocument();
  }

  @Input()
  commentaire?: string;

  @Input()
  documentUrl?: string;

  @Input()
  operationType?: string;

  @Input()
  productType?: string;

  @Input()
  personType?: string;

  @Output()
  close = new EventEmitter();

  constructor(
    private documentService: DocumentsService,
    private slidePanelService: OuiSlidePanelService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon('pdf', sanitizer.bypassSecurityTrustResourceUrl('/assets/file-types/pdf.svg'));
  }

  async initDocument() {
    this.documentUrl = undefined;
    this.creationDate = undefined;
    this.downloadUrl = undefined;
    this.fileName = undefined;

    let fileCacheUrl;
    if (this.storageFile) {
      fileCacheUrl = await this.documentService.fetchAndCacheStorageDocument(this.storageFile);
      this.fileName = this.storageFile.fileName;
      this.creationDate = this.storageFile.createdDate;
    }

    if (fileCacheUrl) {
      this.documentUrl = fileCacheUrl;
    }
  }

  async onDownloadClick() {
    if (!this.storageFile) return;
    await this.documentService.downloadDocumentFromUrl(
      this.storageFile?.fileConnectionInfo?.sasUrl ?? '',
      this._storageFile?.fileName + '.' + this._storageFile?.fileExtension
    );
  }

  closeSlidePanel() {
    this.slidePanelService.closeSlidePanel();
    this.slidePanelService.setSlidePanelContent(null);
  }
}
